import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import Loading from "../LoadingError/Loading";
import Toast from "../LoadingError/Toast";
import MainPanel from "../main-panel/MainPanel";
import Message from "../LoadingError/Error";
import { FAQ_CLEAR } from "../../Redux/Constants/FaqConstants";
import { faqAdd } from "../../Redux/Actions/FaqAction";
import { Box, Button, Checkbox, Flex, Heading, Stack, Text } from "@chakra-ui/react";

const ToastObjects = {
  pauseOnFocusLoss: false,
  draggable: false,
  pauseOnHover: false,
  autoClose: 2000,
};

const AddFaqMain = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const languageList = [
    { id: 1, langKey: "AZ" },
    { id: 2, langKey: "GB" },
    { id: 3, langKey: "RU" },
  ];


  const [status, setStatus] = useState(false);
  const [language, setLanguage] = useState([]);


  const onHandleLangChange = useCallback((dataInfo) => {
    let languageList = {
      name: dataInfo.name,
      description: dataInfo.description,
      seoTitle: dataInfo.seoTitle,
      seoDescription: dataInfo.seoDescription,
      languageKey: dataInfo.lang,
    };
    setLanguage((ln) => [
      ...ln.filter(
        (l) => l.languageKey !== dataInfo.lang && l.languageKey !== ""
      ),
      languageList,
    ]);
  }, []);
  const faqCreate = useSelector((state) => state.faqAdd);
  const { loading, error, faq } = faqCreate;

  useEffect(() => {
    if (faq) {
     toast.success("FAQ successfully added!", ToastObjects);
      setTimeout(() => {
        dispatch({ type: FAQ_CLEAR });
        setStatus();
        history.push("/faqs");
      }, 2000);
    }
  }, [faq, dispatch, history]);



  const submitHandler = (e) => {
    e.preventDefault();
    try {
      dispatch(
        faqAdd({
          faqRecords: language,
          status,
        })
      );
      // toast.success("FAQ successfully added!", ToastObjects);

      setTimeout(() => {
        history.push("/faqs");
      }, 2000);
    } catch {
      toast.error("Failed to add FAQ", ToastObjects);
    }
  };

  return (
    <>
      <Toast />
      <Box maxW="1200px" mx="auto" p={6}>
        <form onSubmit={submitHandler}>
          {/* Header Section */}
          <Flex justify="space-between" align="center" mb={8}>
            <Button
              as={Link}
              to="/faqs"
              colorScheme="red"
              variant="solid"
              _hover={{
                backgroundColor: "red.600",
                color: "white",
              }}
            >
              Go to FAQs
            </Button>


            <Heading as="h2" size="lg" color="teal.600">
              Add FAQ
            </Heading>
            <Button type="submit" colorScheme="teal">
              Publish Now
            </Button>
          </Flex>

          {/* Form Section */}
          <Box bg="white" p={8} borderRadius="lg" shadow="md">
            {/* Language Input */}
            <MainPanel
              mainLang={languageList}
              changeLang={onHandleLangChange}
              languageInfo={language}
            />

            {/* Error & Loading */}
            {error && <Message variant="alert-danger">{error}</Message>}
            {loading && <Loading />}

            {/* Status Checkbox */}
            <Stack spacing={4} mt={6}>
              <Text fontSize="lg" fontWeight="semibold">
                Status
              </Text>
              <Checkbox
                size="lg"
                colorScheme="teal"
                isChecked={status}
                onChange={(e) => setStatus(e.target.checked)}
              >
                Active
              </Checkbox>
            </Stack>
          </Box>
        </form>
      </Box>
    </>
  );
};

export default AddFaqMain;
